import { IActionsCreator } from "types/action";
import { CALL_API } from "../middleware/api";
import {
  GET_LABELS_REQUEST,
  GET_LABELS_SUCCESS,
  GET_LABELS_FAILURE,
} from "./labelsActions";

export const LabelsActionsCreator = {
  getLabels: (
    clientId: string,
    instanceId: string,
    domain: string,
    realm: string,
    language: string,
    payableTypeDefinitions: { typeKrn: string }[],
    payableUi: string,
    successHandler?: any,
    failureHandler?: any
  ): IActionsCreator => ({
    [CALL_API]: {
      types: [GET_LABELS_REQUEST, GET_LABELS_SUCCESS, GET_LABELS_FAILURE],
      request: () =>
        fetchLabels(
          domain,
          clientId,
          realm,
          language,
          instanceId,
          payableTypeDefinitions,
          payableUi
        ),
      successHandler,
      failureHandler,
    },
  }),
};

const fetchLabels = async (
  domain: string,
  clientId: string,
  realm: string,
  language: string,
  instanceId: string,
  payableTypeDefinitions: { typeKrn: string }[],
  payableUi: string
): Promise<any> => {
  const typeKrns = payableTypeDefinitions?.map((item) =>
    item.typeKrn.replace(/:/g, ".")
  );
  
  // if typeKrns exist and payableUI is true then Get Dynamic phrases for payables
  let dynamicPhrases;

  if (typeKrns?.length > 0 && payableUi?.toLowerCase() === "true") {
    // The URLs are constructed based on the following format:
    // https://<domain>/label-management/<clientId>/<realm>/<typeKrn>.web.<language>.json
    const krnFetchUrls = typeKrns.map(
      (typeKrn) =>
        `https://${domain}/label-management/${clientId}/${realm}/${typeKrn}.web.${getFileLanguageFormat(
          language
        )}.json`
    );
  
   // Add clientoverride file as well
    krnFetchUrls.push(`https://${domain}/label-management/${clientId}/${realm}/ezpay.web.${getFileLanguageFormat(language)}.json`);

    // if there are typeKrns, fetch all the URLs and club the results into one object
    const results = await Promise.all(
      krnFetchUrls.map(async (url) => {
        try {
          const response = await fetch(url);
          if (response.ok) {
            return await response.json();
          }
        } catch {
          // Silently handle the error without logging to the console
        }
        return null;
      })
    );

    // Merge all non-null results into a single object
    dynamicPhrases = results
      .filter((res) => res !== null)
      .reduce((acc, curr) => ({ ...acc, ...curr }), {});

    if (Object.keys(dynamicPhrases).length > 0) {
      return Promise.resolve(dynamicPhrases);
    }
    return Promise.reject(new Error("No valid data found from any URL"));
  }

  
  // If not payable ui, Get Legacy Clientoverrides

  const fetchUrls = [
    `https://${domain}/label-management/${clientId}/${realm}/clientoverride_web_${language}.json`,
    `https://${domain}/label-management/${clientId}/${realm}/ezpay6_web_${language}.json`,
    `https://${domain}/label-management/${clientId}/${realm}/${instanceId}_web_${language}.json`
  ];

for (const fetchUrl of fetchUrls) {
        try {
            const response = await fetch(fetchUrl);
            if (response.ok) {
                const jsonData = await response.json();
                if (jsonData) {
                    return Promise.resolve(jsonData);
                }
            }
        } catch (error) {
            // Silently handle the error without logging to the console
        }
    }

  return Promise.reject(new Error("No valid data found from any URL"));
};

function getFileLanguageFormat(language: string): string {
  switch (language) {
    case "en":
      return "en.us";
    case "es":
      return "es.us";
    case "fr":
      return "fr.ca";
    default:
      return "en.us"; // Default to English if no match
  }
}

export default LabelsActionsCreator;
